import DashboardResultsTable from "./DashboardResultsTable";

export default DashboardResultsTable;